import { createFileRoute } from "@tanstack/react-router";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";
import { SitesSettingsPage } from "@/components/sites/admin/sites-settings-page";

// Configuración → Sitios: sitios públicos de la empresa (/s/<slug>). Se
// definen en el manifiesto; aquí se listan y se encienden o apagan.
export const Route = createFileRoute("/_authenticated/settings/_layout/sites/")({
  component: SitesSettingsRoute,
});

function SitesSettingsRoute() {
  return (
    <RouteGuardPermissions permissions={[{ module: "custom_fields", actions: ["read"] }]}>
      <SitesSettingsPage />
    </RouteGuardPermissions>
  );
}
